/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.EmbedUrlResponse,
  EmbedUrl: (params: vp.EmbedUrlRequest) => void,
  reset: () => void,
  embedUrlAsync: (params: vp.EmbedUrlRequest) => Promise<vp.EmbedUrlResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostEmbedUrl: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldEmbedUrl, setShouldEmbedUrl] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.EmbedUrlRequest>({
    RedirectURL: '',
  });
  const [response, setResponse] = useState<vp.EmbedUrlResponse>({
    Success: false,
    ErrorMessage: '',
    EmbedURL: '',
    IframeKey: '',
  });

  useEffect(() => {
    if (!shouldEmbedUrl) return () => {};

    const PostEmbedUrl = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postEmbedUrl(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldEmbedUrl) void PostEmbedUrl();
    setShouldEmbedUrl(false);
    return () => {
      source.cancel();
    };
  }, [shouldEmbedUrl]);

  return [
    response,
    (_params: vp.EmbedUrlRequest) => {
      setParams(_params);
      setShouldEmbedUrl(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        EmbedURL: '',
        IframeKey: '',
      });
      setShouldEmbedUrl(false);
    },
    (_params: vp.EmbedUrlRequest) => api.postEmbedUrl(_params, source),
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostEmbedUrl);
